module.exports = __webpack_public_path__ + "img/above-and-beyond.795b1389.jpg";